export default __webpack_public_path__ + "static/media/edit-icon.4b0bd016.svg";